import { CheckCircle2, Award, Users, Wrench } from "lucide-react";
import { ASSETS } from "@/lib/assets";

const POINTS = [
  "Lang erfaring innen energioppgradering av boliger",
  "Egne fagfolk – ingen underleverandører på kjernearbeid",
  "Lokal forankring i Sveio og Vestland-regionen",
  "Tydelig kommunikasjon og dokumentert utførelse",
];

const STATS = [
  { icon: Award, k: "10+", v: "År i bransjen" },
  { icon: Users, k: "100%", v: "Fornøyde kunder" },
  { icon: Wrench, k: "6+", v: "Fagområder" },
];

export default function About() {
  return (
    <section id="om-oss" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image side */}
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute -inset-2 rounded-3xl gradient-brand opacity-15 blur-2xl" />
              <div className="relative overflow-hidden rounded-3xl border hairline">
                <img
                  src={ASSETS.teamPhoto}
                  srcSet="/brand/team-sm.jpg 480w, /brand/team.jpg 720w"
                  sizes="(max-width: 768px) 90vw, 520px"
                  alt="Høie Service håndverkere"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-[520px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--hs-bg))] via-transparent to-transparent opacity-60" />
              </div>
              {/* Floating stat card */}
              <div className="absolute -bottom-6 -right-4 sm:-right-8 glass rounded-2xl p-5 max-w-[260px]">
                <div className="mono text-[10px] uppercase tracking-[0.22em] text-cyan mb-2">
                  / Fokus
                </div>
                <div className="text-xl font-bold text-white leading-snug">
                  Ditt innemiljø er vårt fokus.
                </div>
              </div>
            </div>
          </div>

          {/* Copy side */}
          <div className="lg:col-span-7">
            <div className="mono text-[11px] uppercase tracking-[0.3em] text-cyan mb-5 reveal">
              / Om Høie Service
            </div>
            <h2 className="reveal text-4xl sm:text-5xl lg:text-[58px] font-bold text-white leading-[1.02] mb-7" data-testid="about-headline">
              Et håndverker­firma som faktisk
              <span className="text-gradient"> bryr seg om sluttresultatet.</span>
            </h2>
            <p className="reveal text-white/70 text-lg leading-relaxed mb-8 max-w-2xl">
              Høie Service AS er et lokalt forankret håndverkerfirma som spesialiserer
              seg på energioppgradering av boliger. Med høy kompetanse, riktig
              utstyr og personlig oppfølging leverer vi arbeid som varer –
              og som kutter strømregningen din.
            </p>

            <ul className="space-y-3 mb-10">
              {POINTS.map((p, i) => (
                <li
                  key={p}
                  className="reveal flex items-start gap-3 text-white/85"
                  style={{ transitionDelay: `${i * 80}ms` }}
                  data-testid={`about-point-${i}`}
                >
                  <CheckCircle2 className="w-5 h-5 text-cyan shrink-0 mt-0.5" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              {STATS.map((s, i) => {
                const Icon = s.icon;
                return (
                  <div
                    key={s.v}
                    className="reveal p-5 rounded-2xl border hairline bg-[hsl(var(--hs-bg-2))]"
                    style={{ transitionDelay: `${i * 100}ms` }}
                  >
                    <Icon className="w-5 h-5 text-coral mb-3" />
                    <div className="text-3xl font-bold text-white">{s.k}</div>
                    <div className="mono text-[10px] uppercase tracking-[0.18em] text-white/50 mt-1">
                      {s.v}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
